import { components } from '../../tokens/components/bluestone';
import { DeprecatedTheme } from '../types';
import colorsGO from './colors/base/GO';
import alertTokens from './components/alert.tokens';
import createButtonTokens from './components/button.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import pillTokens from './components/pill.tokens';
import radioButtonBoxTokens from './components/radioButton.tokens';
import sliderTokens from './components/slider.tokens';
import ED from './ED';

const uniqueBackground = '#66C431';
const uniqueForeground = '#2D7D00';
const colorsBrand = { 0: '#F7FBEB', 1: '#A5CD38', 2: '#7CA82B' };
const brandSecondary = '#6CAE00';

const {
  colors: colorsED,
  radii,
  borders,
  space,
  fontSizes,
  sizes,
  lineHeights,
  fontWeights,
} = ED;

const colors = {
  ...colorsED,
  ...colorsGO,
  brandPrimary: colorsBrand,
  promotional: {
    primary: {
      default: '#123300',
      dark: '#0B1F00',
    },
    secondary: {
      default: uniqueBackground,
      dark: '#215C00',
    },
  },
};
const { neutrals: colorsGrey } = colors;
const fontSizeBody = fontSizes.body;

const button = createButtonTokens({
  colors,
  colorsBrand,
  radii,
  borders,
  space,
  fontSizeBody,
});
const drawerHeader = drawerHeaderTokens({
  colorsBrand,
  colors,
  borders,
  space,
});
const slider = sliderTokens({
  colors,
  colorsBrand,
  sizes,
  space,
  fontSizeBody,
});
const checkbox = checkboxTokens({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
});
const radioButton = radioButtonBoxTokens({
  borders,
  colors,
  colorsBrand,
  lineHeights,
  fontSizeBody,
  fontWeights,
});
const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const pill = pillTokens({ colors, colorsGrey });

const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const GO: DeprecatedTheme = {
  ...ED,
  colors: {
    ...colors,
    text: colors,
    brandSecondary,
    deprecatedAppBannerColors: '#F5F5F5',
    appBanner: {
      ...ED.colors.appBanner,
      bt: brandSecondary,
      image: '/images/onefront/bluestone/GV/govoyages_app_background.png',
      uniqueBackground,
      uniqueForeground,
    },
    banner: {
      bg: '#123300',
      fg: brandSecondary,
      gradient: ['#123300', '#0B1F00'],
    },
    button: button.colors,
    drawerHeader: drawerHeader.colors,
    slider: slider.colors,
    checkbox: checkbox.colors,
    radioButton: radioButton.colors,
    brandedProgressBar: brandSecondary,
    decorationLine: {
      ...colors.decorationLine,
      default: brandSecondary,
    },
    switchSlider: {
      ...colors.switchSlider,
      checkedBg: colorsBrand[1],
    },
    lightButtonBgColor: colorsBrand[0],
    darkButtonTextColor: '#680',
    input: input.colors,
    pill: pill.colors,
    alert: alert.colors,
    calendar: calendar.colors,
  },
  borders: {
    ...ED.borders,
    alert: alert.borders,
  },
  components,
};

export default GO;
